import React from 'react'
import styled from 'styled-components'
import { Benefit } from './Benefit'
import { data } from './data'

const BenefitsContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 24px;
  padding: 32px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);

  @media (min-width: 681px) {
    box-shadow: none;
  }
`

export const Benefits = () => (
  <BenefitsContainer>
    {data.map(props => (
      <Benefit key={props.title} {...props} />
    ))}
  </BenefitsContainer>
)
